import React, { useContext } from "react";
import { string } from "prop-types";
import TransactionStatus from "pages/transactions/_components/TransactionStatus";
import * as i18n from "util/i18n";
import { EcheqTransactionContext } from "./EcheqTransactionContext";

export const EcheqTransactionHeader = ({ title, subTitle }) => {
    const { transaction } = useContext(EcheqTransactionContext);
    const _subTitle = `ticket.status.${transaction.idTransactionStatus}`;

    return (
        <>
            <div className="media-object column">
                {title && (
                    <div className="text-center">
                        <h1 className="hidden md:block">{i18n.get(title, "Solicitud de descuento de Echeqs")}</h1>
                        <h3>{subTitle || i18n.get(_subTitle)}</h3>
                    </div>
                )}
                {!title && (
                    <div className="media-object--text">
                        <h5>
                            {i18n.get(`forms.transaction.ticket.status.${transaction.idTransactionStatus}.firstTitle`)}
                        </h5>
                    </div>
                )}
                <figure>
                    <TransactionStatus iconFidelity="ticket" idTransactionStatus={transaction.idTransactionStatus} />
                </figure>
            </div>
        </>
    );
};

EcheqTransactionHeader.propTypes = {
    title: string,
    subTitle: string,
};

EcheqTransactionHeader.defaultProps = {
    title: "",
    subTitle: "",
};

export default EcheqTransactionHeader;
